import { Icon } from '@mui/material';
import MDButton from 'components/MDButton';

export default function BranchTable() {


    const formCountryRows = (data) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                description: dt.description,
                code: dt.code
            });
        }
        return result;
    };

    const formCarrierRows = (data) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                description: dt.description,
                type: dt.type
            });
        }
        return result;
    };

    const formCorporateRows = (data) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name
            });
        }
        return result;
    };

    const formPaymentModeRows = (data, editPaymentMode) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                action: <MDButton variant="outlined" color="info" iconOnly onClick={() => { editPaymentMode(dt); }}>
                    <Icon>edit</Icon>
                </MDButton>
            });
        }
        return result;
    };

    const formReceivingAccountRows = (data, editReceivingAccount) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                action: <MDButton variant="outlined" color="info" iconOnly onClick={() => { editReceivingAccount(dt); }}>
                    <Icon>edit</Icon>
                </MDButton>
            });
        }
        return result;
    };

    const formTemplateRows = (data, editTemplate) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                variables: dt.variables,
                action: <MDButton variant="outlined" color="info" iconOnly onClick={() => { editTemplate(dt); }}>
                    <Icon>edit</Icon>
                </MDButton>
            });
        }
        return result;
    };

    const formDeclarationRows = (data, editDeclaration) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                content: dt.content,
                action: <MDButton variant="outlined" color="info" iconOnly onClick={() => { editDeclaration(dt); }}>
                    <Icon>edit</Icon>
                </MDButton>
            });
        }
        return result;
    };

    const formTrackingMessageRows = (data, editTrackingMessage) => {
        let result = [];
        for (let dt of data) {
            result.push({
                name: dt.name,
                content: dt.content,
                status: dt.is_active ? "Active" : "Inactive",
                action: <MDButton variant="outlined" color="info" iconOnly onClick={() => { editTrackingMessage(dt); }}>
                    <Icon>edit</Icon>
                </MDButton>
            });
        }
        return result;
    };

    return {
        formCountryRows,
        formCarrierRows,
        formCorporateRows,
        formPaymentModeRows,
        formReceivingAccountRows,
        formTemplateRows,
        formDeclarationRows,
        formTrackingMessageRows,
        countryHeaders: [
            { Header: "Name", accessor: "name", align: "center" },
            { Header: "Description", accessor: "description", align: "center" },
            { Header: "Code", accessor: "code", align: "center" }
        ],
        carrierHeaders: [
            { Header: "Name", accessor: "name", align: "center" },
            { Header: "Type", accessor: "type", align: "center" },
            { Header: "Description", accessor: "description", align: "center" }
        ],
        corporateHeaders: [
            { Header: "Name", accessor: "name", align: "center" }
        ],
        paymentModeHeaders: [
            { Header: "Name", accessor: "name", align: "center" },
            { Header: "Action", accessor: "action", align: "center" }
        ],
        receivingAccountHeaders: [
            { Header: "Name", accessor: "name", align: "center" },
            { Header: "Action", accessor: "action", align: "center" }
        ],
        templateHeaders: [
            { Header: "Name", accessor: "name", align: "center" },
            { Header: "Variables", accessor: "variables", align: "center" },
            { Header: "Action", accessor: "action", align: "center" }
        ],
        declarationHeaders: [
            { Header: "Name", accessor: "name", align: "center" },
            { Header: "Content", accessor: "content", align: "center" },
            { Header: "Action", accessor: "action", align: "center" }
        ],
        trackingMessageHeaders: [
            { Header: "Name", accessor: "name", align: "center" },
            { Header: "Content", accessor: "content", align: "center" },
            { Header: "Status", accessor: "status", align: "center" },
            { Header: "Action", accessor: "action", align: "center" }
        ],
    };
}
